/* AMBELA media blocks: lazy looping videos. Load when near the screen, pause when off it. */
(function () {
  if (window.__amxVideos) return; window.__amxVideos = true;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function shown(el) { return getComputedStyle(el).display !== 'none'; }
  function start(el) {
    if (!el.src && el.dataset.src) el.src = el.dataset.src;
    el.muted = true;
    if (!still) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting && shown(e.target)) start(e.target);
      else if (e.target.src) e.target.pause();
    });
  }, { rootMargin: '200px 0px' }) : null;
  function scan(root) {
    (root || document).querySelectorAll('video[data-amx-lazy]:not([data-amx-seen])').forEach(function (el) {
      el.setAttribute('data-amx-seen', '');
      if (io) io.observe(el); else if (shown(el)) start(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();